import React, { useState } from 'react'
import { Stepper } from 'react-form-stepper';
import './ServicesForm1.css'


function TaxDetail({taxyear, natureofbusiness,
                    turnover, tips, otherbusinessincome, fuel, insurance, radiorent, licensingfee, mobilecommunication, repair, accountingcost,
                    bankcharges, otherexpense, car, carmileage, capitalpersonaluse, personaluse, otherincomeincludeproperty, valueofcar
    , caremission, step, setstep, settaxyear, setnatureofbusiness, setturnover, settips, formSubmitHondler,  setotherbusinessincome,  setfuel,  setinsurance,  setradiorent,  setlicensingfee,  setmobilecommunication,  setrepair,  setaccountingcost,  setbankcharges,  setotherexpense,  setcar,  setcarmileage,  setcapitalpersonaluse,  setpersonaluse,  setotherincomeincludeproperty,  setvalueofcar,  setcaremission, loading}) {

    // const [firstname, setfirstname] = useState();
    // const [lastname, setlastname] = useState();
    // const [email, setemail] = useState();
    // const [phone, setphone] = useState();
    // const [services, setservices] = useState();
    // const [soletrader, setsoletrader] = useState();
    // const [privatedriver, setprivatedriver] = useState();
    // const [deliverydriver, setdeliverydriver] = useState();
    // const [cis, setcis] = useState();
    // const [taxidriver, settaxidriver] = useState();
    // const [onlineseller, setonlineseller] = useState();
    // const [other, setother] = useState();
    // const [propertyaccount, setpropertyaccount] = useState();
    // const [companyname, setcompanyname] = useState();
    // const [companynumber, setcompanynumber] = useState();
    // const [paye, setpaye] = useState();
    // const [message, setmessage] = useState();    
    // const [nextstep, setnextstep] = useState(1);



    // const submithandle = (e) => {
    //     e.preventDefault()
    //     setstep(step + 1)
    // }


    return (
        <div>
            <div className='stepper-div1'>
                {/* <Stepper activeStep={0} steps={[{ label: 'Personal Detail' }, { label: 'Services' }, { label: 'Complete' }]} styleConfig={{
                    activeBgColor: '#485CE1',
                    activeTextColor: '#fff',
                    inactiveBgColor: '#fff',
                    inactiveTextColor: '#3033B5',
                    completedBgColor: '#2729a1',
                    completedTextColor: '#fff',
                    size: '3em'
                    
                }} className={ 'stepper'}
            stepClassName={ 'stepper__step'}>
                </Stepper> */}

                <div className='stepper-main-div1'>
                    <div className='stepper-main-div2'>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1-complete'><span>1</span></button>
                            <div className='stepper-main-div4'>
                                <span>Personal Detail</span>
                            </div>
                        </div>
                    </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1-active'><span>2</span></button>
                            <div className='stepper-main-div4'>
                                <span>Tax Detail</span>
                            </div>
                        </div>
                    </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1'><span>3</span></button>
                            <div className='stepper-main-div4'>
                                <span>Complete</span>
                            </div>
                        </div>
                    </div>
                </div>


                <form className="service-contact-form" onSubmit={formSubmitHondler}>

                    <div class="row">


                        <div className='col-12'>
                            <h1 className='forms-heading12 mt-0'> Tax Year</h1>
                        </div>

                        <div class="col-lg-12 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Tax Year</label>

                            <input
                                type='text'
                                name="taxyear"
                                class="form-control contact-input-field5"
                                placeholder="Tax Year"
                                onChange={(e) => settaxyear(e.target.value)}
                                value={taxyear}
                            />
                        </div>

                        <div className='col-12'>
                            <h1 className='forms-heading12'> Self Employment Detail</h1>
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Nature of Business</label>

                            <input
                                type='text'
                                name="natureofbusiness"
                                onChange={(e) => setnatureofbusiness(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Nature of Bussiness"
                                value={natureofbusiness}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Turn Over</label>

                            <input
                                type='text'
                                name="turnover"
                                onChange={(e) => setturnover(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Turn Over"
                                value={turnover}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Tips</label>

                            <input
                                type='text'
                                name="tips"
                                onChange={(e) => settips(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Tips"
                                value={tips}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Any Other Income</label>

                            <input
                                type='text'
                                onChange={(e) => setotherbusinessincome(e.target.value)}
                                name="otherbusinessincome"
                                class="form-control contact-input-field5"
                                placeholder="Any Other Income related to Business"
                                value={otherbusinessincome}
                            />
                        </div>

                        <div className='col-12'>
                            <h1 className='forms-heading12'>Expense</h1>
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Fuel</label>

                            <input
                                type='text'
                                name="fuel"
                                class="form-control contact-input-field5"
                                placeholder="Fuel"
                                onChange={(e) => setfuel(e.target.value)}
                                value={fuel}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Insurance</label>

                            <input
                                type='text'
                                name="insurance"
                                onChange={(e) => setinsurance(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Insurance"
                                value={insurance}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Radio Rent</label>

                            <input
                                type='text'
                                name="radiorent"
                                onChange={(e) => setradiorent(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Radio Rent"
                                value={radiorent}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Licensing Fee</label>

                            <input
                                type='text'
                                name="licensingfee"
                                onChange={(e) => setlicensingfee(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Licensing Fee"
                                value={licensingfee}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Mobile & other Communication</label>

                            <input
                                type='text'
                                name="mobilecommunication"
                                onChange={(e) => setmobilecommunication(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Mobile & other Communication Expenses"
                                value={mobilecommunication}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Repair</label>

                            <input
                                type='text'
                                name="repair"
                                onChange={(e) => setrepair(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Repir Expenses"
                                value={repair}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Accounting Cost</label>

                            <input
                                type='text'
                                name="accountingcost"
                                onChange={(e) => setaccountingcost(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Accounting Cost Expenses"
                                value={accountingcost}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Bank Charges</label>

                            <input
                                type='text'
                                name="bankcharges"
                                onChange={(e) => setbankcharges(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Bank Charges"
                                value={bankcharges}
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Other</label>

                            <input
                                type='text'
                                name="otherexpense"
                                onChange={(e) => setotherexpense(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Other Expenses"
                                value={otherexpense}
                            />
                        </div>

                        <div className='col-12'>
                            <h1 className='forms-heading12'>Vehicle Information</h1>
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Do you own car?</label>
                            <div className='row' style={{ 'paddingLeft': '15px' }}>

                                <div className='col-6 d-flex align-items-center'>
                                    <input
                                        type='radio'
                                        name="car"
                                        class="form-check-input contact-input-field5"
                                        placeholder="Yes"
                                        value='Yes'
                                        onChange={(e) => { setcar(e.target.value) }}
                                    />
                                    <label className='form-check-label radio-form-labels'>Yes</label>
                                </div>
                                <div className='col-6 d-flex align-items-center'>
                                    <input
                                        type='radio'
                                        name="car"
                                        class="form-check-input contact-input-field5"
                                        placeholder="Yes"
                                        value='No'
                                        onChange={(e) => { setcar(e.target.value) }}
                                    />
                                    <label className='form-check-label radio-form-labels'>No</label>
                                </div>

                            </div>

                        </div>

                        <div className={`${car == "Yes"
                            ? "col-lg-6 col-12 mt-4 mt-lg-5 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Mileage</label>

                            <input
                                type='text'
                                name="carmilage"
                                onChange={(e) => setcarmileage(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Mileage during the year"
                                value={carmileage}

                            />
                        </div>


                        <div className='col-12'>
                            <h1 className='forms-heading12'>Capital Allowance</h1>
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Personal Use?</label>
                            <div className='row' style={{ 'paddingLeft': '15px' }}>

                                <div className='col-6 d-flex align-items-center'>
                                    <input
                                        type='radio'
                                        name='capitalpersonaluse'
                                        class="form-check-input contact-input-field5"
                                        placeholder="Yes"
                                        value='Yes'
                                        onChange={(e) => { setcapitalpersonaluse(e.target.value) }}
                                    />
                                    <label className='form-check-label radio-form-labels'>Yes</label>
                                </div>
                                <div className='col-6 d-flex align-items-center'>
                                    <input
                                        type='radio'
                                        class="form-check-input contact-input-field5"
                                        placeholder="Yes"
                                        name='capitalpersonaluse'
                                        value='No'
                                        onChange={(e) => { setcapitalpersonaluse(e.target.value) }}
                                    />
                                    <label className='form-check-label radio-form-labels'>No</label>
                                </div>

                            </div>

                        </div>

                        <div className={`${capitalpersonaluse == "Yes"
                            ? "col-lg-6 col-12 mt-4 mt-lg-5 d-block"
                            : "d-none"
                            }`}>
                            <label className='form-labels'>Personal Use</label>

                            <input
                                type='text'
                                name="personaluse"
                                onChange={(e) => setpersonaluse(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Percentage of Personal Use"
                                value={personaluse}

                            />
                        </div>

                        <div className='col-12'>
                            <h1 className='forms-heading12'>Other Income</h1>
                        </div>

                        <div class="col-lg-12 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Other Income Including Property Income</label>

                            <input
                                type='text'
                                name="otherincomeincludeproperty"
                                onChange={(e) => setotherincomeincludeproperty(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Specify any Other Income Including Property Income"
                                value={otherincomeincludeproperty}
                            />
                        </div>


                        <div className='col-12'>
                            <h1 className='forms-heading12'>Car Details</h1>
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Value of Car</label>

                            <input
                                type='text'
                                name="valueofcar"
                                onChange={(e) => setvalueofcar(e.target.value)}
                                class="form-control contact-input-field5"
                                value={valueofcar}
                                placeholder="Value of Car at the start of the financial Year"
                            />
                        </div>

                        <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                            <label className='form-labels'>Car Emission</label>

                            <input
                                type='text'
                                name="caremission"
                                onChange={(e) => setcaremission(e.target.value)}
                                class="form-control contact-input-field5"
                                placeholder="Car Emission for capital allowance purpose"
                                value={caremission}
                            />
                        </div>

                        <div className='d-flex w-100 justify-content-end pr-2'>
                            <div className="mt-5 contact-us-btn-div2">
                                <button
                                    // type="submit"
                                    onClick={(() => { setstep(step - 1) })}
                                    className="ml-sm-auto mx-sm-0 mx-auto contactus-form-btn4"
                                >
                                    Back

                                </button>
                            </div>

                            <div className="mt-5 contact-us-btn-div2 ml-4">
                                <button
                                    type="submit"
                                    className="ml-sm-auto mx-sm-0 mx-auto contactus-form-btn4 "
                                >
                                    {loading ? "Please Wait..." : 'Submit'}
                                </button>
                            </div>
                        </div>


                    </div>
                </form>
            </div>
        </div>
    )
}

export default TaxDetail
